"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var SearchBarContext_1 = __importDefault(require("../SearchBarContext"));
var utils_1 = require("../utils");
function useGetSuggestionHref() {
    var refSource = (0, react_1.useContext)(SearchBarContext_1.default).refSource;
    return function (href, eventData) {
        var url = new URL("https://www.example.com".concat(href));
        url.searchParams.set('refSource', refSource);
        if (Object.keys(eventData).length)
            url.searchParams.set('searchEvent', (0, utils_1.encodeAndStringify)(eventData));
        return url.pathname + url.search;
    };
}
exports.default = useGetSuggestionHref;
//# sourceMappingURL=useGetSuggestionHref.js.map